// extracted by mini-css-extract-plugin
module.exports = {"city-text-input":"CityTextInput_city-text-input__3z7fF","icon-location":"CityTextInput_icon-location__VGff2"};